export const baseURL = process.env.REACT_APP_API ?? ''
export const baseURL_V2 = process.env.REACT_APP_API_V2 ?? ''
export const baseURL_PdfExpress = process.env.REACT_APP_PDF_EXPRESS ?? ''
